// Store cache-busting timestamps for different image URLs
const imageCacheMap = new Map<string, number>();

/**
 * Gets or creates a cache-busting timestamp for an image URL
 */
const getCacheBustingTimestamp = (imageUrl: string): number => {
  if (!imageCacheMap.has(imageUrl)) {
    imageCacheMap.set(imageUrl, Date.now());
  }
  return imageCacheMap.get(imageUrl)!;
};

/**
 * Forces a new cache-busting timestamp for an image URL
 */
export const refreshImageCache = (imageUrl: string): void => {
  imageCacheMap.set(imageUrl, Date.now());
};

/**
 * Adds a cache-busting parameter to profile picture URLs to prevent browser caching
 * when users upload new photos to the same S3 path
 */
export const getCacheBustedImageUrl = (imageUrl: string | null | undefined): string => {
  const defaultImage = "/dubuFace260.jpg";
  
  if (!imageUrl) {
    return defaultImage;
  }
  
  // If it's already a cache-busted URL, return as is
  if (imageUrl.includes('?t=')) {
    return imageUrl;
  }
  
  // If it's the default image, don't add cache-busting
  if (imageUrl === defaultImage || imageUrl.includes('dubuFace260')) {
    return imageUrl;
  }
  
  // Add cache-busting parameter for S3 URLs
  if (imageUrl.includes('s3.') || imageUrl.includes('amazonaws.com')) {
    const timestamp = getCacheBustingTimestamp(imageUrl);
    return `${imageUrl}?t=${timestamp}`;
  }
  
  // For other URLs, return as is
  return imageUrl;
};

/**
 * Handles image error by setting to default image
 */
export const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
  event.currentTarget.src = "/dubuFace260.jpg";
  event.currentTarget.onerror = null;
}; 